import Microgame from '../engine/Microgame.js';

export default class WhackGame extends Microgame {

    static getPlayback() {
        return {
            title: { fr: `Tape-Taupe !`, en: `Whack!`, es: `¡Golpea!` },
            controls: { fr: `Appuie sur l'élément quand il sort du trou`, en: `Tap the element when it pops out of the hole`, es: `Toca el elemento cuando salga del agujero` },
            objective: { fr: `Tape tout ce qui bouge mais évite les bombes`, en: `Whack everything that pops up but avoid bombs`, es: `Golpea todo lo que salga, excepto las bombas` },
            icon: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="var(--primary-color)" stroke-width="2"><path d="M15 15V9a3 3 0 0 0-6 0v6M3 15h18M6 15v3a3 3 0 0 0 6 0M18 15v3a3 3 0 0 1-6 0"/></svg>`,
            actions: [
                { type: 'wait', duration: 320 },
                { type: 'tapTarget', selector: 'div[style*="cursor: pointer"]', duration: 220 },
                { type: 'wait', duration: 380 },
                { type: 'tapTarget', selector: 'div[style*="cursor: pointer"]', duration: 220 },
                { type: 'wait', duration: 380 },
            ],
            loopDuration: 3000
        };
    }
    constructor(engine) {
        super(engine);
        this.holes = [];
        this.score = 0;
        // Fix: In Infinite Challenge, targetScore should be effectively infinite, otherwise we trigger 'win' by score.
        const isInfinite = this.engine.activeChallenge && (this.engine.activeChallenge.mode === 'infinite' || this.engine.activeChallenge.mode === 'infinite_no_timer');
        if (isInfinite) {
            // Only config overrides infinity, otherwise let it run forever until time/lives
            this.targetScore = (this.engine.activeChallenge.config && this.engine.activeChallenge.config.targetScore) || Infinity;
        } else if (this.engine.activeChallenge) {
            this.targetScore = (this.engine.activeChallenge.config && this.engine.activeChallenge.config.targetScore) || 3;
        } else {
            // STANDARD (ALL GAMES) mode: 1 whack = win
            this.targetScore = 1;
        }
        this.spawnInterval = 0.6;
        this.timer = 0;
    }

    setup() {
        this.engine.ui.instruction.textContent = "WHACK!";

        // Create Grid of Holes
        const grid = document.createElement('div');
        grid.style.display = 'grid';
        grid.style.gridTemplateColumns = 'repeat(3, 1fr)';
        grid.style.gap = '20px';
        grid.style.width = '300px';
        grid.style.position = 'absolute';
        grid.style.top = '50%';
        grid.style.left = '50%';
        grid.style.transform = 'translate(-50%, -50%)';
        this.container.appendChild(grid);

        for (let i = 0; i < 9; i++) {
            const hole = document.createElement('div');
            hole.style.width = '80px';
            hole.style.height = '80px';
            hole.style.background = '#333';
            hole.style.borderRadius = '50%';
            hole.style.position = 'relative';
            hole.style.overflow = 'hidden';
            hole.style.border = '2px solid #555';

            // Mole
            const mole = document.createElement('div');
            mole.style.width = '60px';
            mole.style.height = '60px';
            mole.style.background = this.primaryColor;
            mole.style.borderRadius = '50%';
            mole.style.position = 'absolute';
            mole.style.top = '100%'; // Hidden
            mole.style.left = '50%';
            mole.style.transform = 'translateX(-50%)';
            mole.style.transition = 'top 0.1s';
            mole.style.cursor = 'pointer';

            mole.addEventListener('pointerdown', (e) => {
                e.stopPropagation(); // Prevent double taps
                this.whack(mole);
            });

            hole.appendChild(mole);
            grid.appendChild(hole);
            this.holes.push({ element: hole, mole: mole, active: false });
        }

        this.spawnMole();
    }

    spawnMole() {
        if (!this.active) return;

        const available = this.holes.filter(h => !h.active);
        if (available.length === 0) return;

        const target = available[Math.floor(Math.random() * available.length)];
        target.active = true;
        target.mole.style.top = '10px'; // Pop up

        // Auto hide after random time
        setTimeout(() => {
            if (!this.active || !target.active) return;
            target.mole.style.top = '100%';
            target.active = false;
        }, 800 + Math.random() * 400);
    }

    whack(mole) {
        const holeObj = this.holes.find(h => h.mole === mole);
        if (holeObj && holeObj.active) {
            holeObj.active = false;
            mole.style.top = '100%';

            // Visual feedback
            mole.style.background = this.secondaryColor;
            setTimeout(() => mole.style.background = this.primaryColor, 100);

            this.score++;
            if (this.score >= this.targetScore) {
                this.win();
            }
        }
    }

    update(dt) {
        this.timer += dt / 1000;
        if (this.timer > this.spawnInterval) {
            this.spawnMole();
            this.timer = 0;
            // Increase speed if infinite
            if (this.engine.activeChallenge && this.engine.activeChallenge.mode === 'infinite') {
                this.spawnInterval = Math.max(0.2, this.spawnInterval * 0.98);
            } else {
                this.spawnInterval = Math.max(0.3, this.spawnInterval * 0.95);
            }
        }

        // Update Score for Infinite
        if (this.engine.activeChallenge && this.engine.activeChallenge.mode === 'infinite') {
            this.engine.score = this.score;
            this.engine.updateHUD();
        }
    }

    onTimeout() {
        // In challenge (infinite/score attack), timeout is just end of run, not a fail
        if (this.engine.activeChallenge) return true;
        // In STANDARD mode, timeout = fail
        return false;
    }
}
